if (!customElements.get('wls-header')) {
    class WLSHeader extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                isMobile: window.innerWidth <= 1024,
                openClass: 'open',
                rotateClass: 'rotate',
                hamburger: 'js-wls-header-hamburger',
                menu: 'js-wls-block-megamenu',
                menuClose: 'js-wls-header-menu-close',
                menuItem: 'wls-megamenu-collection',
                deskMenuItems: 'js-wls-block-header-nav-link',
            };

            this.elements = {
                hamburger: this.querySelector(`.${this.classes.hamburger}`),
                menu: this.querySelector(`.${this.classes.menu}`),
                menuClose: this.querySelector(`.${this.classes.menuClose}`),
                menuItems: this.querySelectorAll(`.${this.classes.menuItem}`),
                deskMenuItems: this.querySelectorAll(`.${this.classes.deskMenuItems}`),
            };

            document.addEventListener("DOMContentLoaded", () => this.initialize());
        }

        initialize() {
            this.mobileMenuFunctionality();
        }

        mobileMenuFunctionality() {
            if (this.classes.isMobile) {
                this.setupMobileMenu();
            } else {
                this.setupDesktopMenu();
            }
        }

        // Mobile menu functionality
        setupMobileMenu() {
            if (this.elements.hamburger && this.elements.menu && this.elements.menuClose) {
                this.elements.hamburger.addEventListener('click', () => {
                    this.elements.menu.classList.add(this.classes.openClass);
                    document.body.style.overflow = 'hidden';
                });

                this.elements.menuClose.addEventListener('click', () => {
                    this.elements.menu.classList.remove(this.classes.openClass);
                    document.body.style.overflow = 'visible';
                });
            }

            if (this.elements.menuItems.length > 0) {
                this.elements.menuItems.forEach(item => {
                    item.addEventListener('click', (e) => this.handleSubMenuClick(e, item));
                });
            }
        }

        // Submenu functionality

        handleSubMenuClick(e, item) {
            const itemMenu = item.querySelector('.js-wls-megamenu-products');
            if (!itemMenu) return;

            if (e.target.classList.contains('wls-megamenu-collection__products-close') || e.target.closest('.wls-megamenu-collection__products-close')) {
                itemMenu.style.display = 'none';
                document.body.style.overflow = 'visible';
            } else {
                itemMenu.style.display = 'block';
                document.body.style.overflow = 'hidden';
            }
        }

        // Desktop menu functionality

        setupDesktopMenu() {
            if (this.elements.deskMenuItems.length > 0) {
                this.elements.deskMenuItems.forEach(item => {
                    const parent = item.parentElement;
                    const dropdown = parent.querySelector('.js-wls-block-megamenu');
                    const arrow = item.querySelector('.wls-icon-arrow-down');

                    if (dropdown) {

                        dropdown.classList.remove(this.classes.openClass);
                        arrow.classList.remove(this.classes.rotateClass);
                        document.body.style.overflow = 'visible';


                        item.addEventListener('mouseenter', () => {
                            this.closeAllDropdowns();
                            dropdown.classList.add(this.classes.openClass);
                            arrow.classList.add(this.classes.rotateClass);
                            document.body.style.overflow = 'hidden';
                        });


                        item.addEventListener('mouseleave', () => {
                            this.closeDropdownWithDelay(item, dropdown);
                        });


                        dropdown.addEventListener('mouseenter', () => {
                            dropdown.classList.add(this.classes.openClass);
                            arrow.classList.add(this.classes.rotateClass);
                            document.body.style.overflow = 'hidden';
                        });


                        dropdown.addEventListener('mouseleave', () => {
                            this.closeDropdownWithDelay(item, dropdown);
                        });
                    }
                });
            }
        }

        closeAllDropdowns() {
            this.elements.deskMenuItems.forEach(item => {
                const parent = item.parentElement;
                const dropdown = parent.querySelector('.js-wls-block-megamenu');
                const arrow = item.querySelector('.wls-icon-arrow-down');

                if (dropdown) {
                    dropdown.classList.remove(this.classes.openClass);
                }
                if (arrow) {
                    arrow.classList.remove(this.classes.rotateClass);
                }
            });

            document.body.style.overflow = 'visible';
        }

        closeDropdownWithDelay(item, dropdown) {
            const delay = 600;
            const arrow = item.querySelector('.wls-icon-arrow-down');
            setTimeout(() => {
                const isMouseOutside = !item.matches(':hover') && !dropdown.matches(':hover');
                if (isMouseOutside) {
                    dropdown.classList.remove(this.classes.openClass);
                    arrow.classList.remove(this.classes.rotateClass);
                    document.body.style.overflow = 'visible';
                }
            }, delay);
        }

    }

    window.customElements.define('wls-header', WLSHeader);
}
